// One zoom level, shared, because it marks one moment.
//
// Below it the map is a map of CAMPUS — you are working out roughly where
// things are, and every label has to earn its space against fifty others.
// At it and closer the map is about where you are standing: one building fills
// a chunk of the screen, and the detail that would have been noise is the
// whole reason you zoomed in.
//
// Two things hang off that moment — a bus stop's next departures and a parking
// lot's full name and status — and they must agree, because they sit on the
// same screen a few hundred metres apart. Two constants a level apart made the
// map arrive in stages, which reads as one of them being broken.
//
// One constant is not enough on its own: both must also act on the same
// SIGNAL. The bus labels turn over when the map goes idle, so the lot labels
// are told to (`setDetail`, driven from useRouteLayer's idle listener) rather
// than reading the zoom inside their own draw() — which flipped them part-way
// through a pinch, the same threshold arriving at a visibly different instant.
export const DETAIL_ZOOM = 17;
